import Grid from '@mui/material/Grid'
import Paper from '@mui/material/Paper'
import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'

export type SkeletonEditableRowsProps = {
    rows?: number
    toggles?: number
    headerAction?: boolean
}

export default function SkeletonEditableRows(props: Readonly<SkeletonEditableRowsProps>) {
    const { rows = 8, toggles = 2, headerAction = false } = props

    return (
        <Grid container spacing={2} size={12}>
            <Grid size={12}>
                <Paper sx={{ p: 2 }}>
                    <Skeleton variant="text" width={180} sx={{ fontSize: '1.5rem' }} />
                </Paper>
            </Grid>

            <Grid size={12}>
                <Paper sx={{ p: 3 }}>
                    {headerAction && (
                        <Stack direction="row" sx={{ justifyContent: 'flex-end', mb: 2 }}>
                            <Skeleton variant="rounded" width={150} height={40} />
                        </Stack>
                    )}

                    <Stack direction="row" spacing={3} sx={{ px: 1, pb: 1 }}>
                        <Skeleton variant="text" width="45%" />
                        {Array.from({ length: toggles }, (_, index) => (
                            <Skeleton key={index} variant="text" width={90} />
                        ))}
                    </Stack>

                    {Array.from({ length: rows }, (_, row) => (
                        <Stack
                            key={row}
                            direction="row"
                            spacing={3}
                            sx={{
                                px: 1,
                                py: 1.5,
                                alignItems: 'center',
                                bgcolor: row % 2 === 0 ? 'action.hover' : 'transparent',
                            }}
                        >
                            <Skeleton variant="text" sx={{ flexGrow: 1 }} />
                            {Array.from({ length: toggles }, (_, index) => (
                                <Skeleton
                                    key={index}
                                    variant="rounded"
                                    width={20}
                                    height={20}
                                    sx={{ mx: 4 }}
                                />
                            ))}
                            <Skeleton variant="circular" width={22} height={22} />
                        </Stack>
                    ))}

                    <Skeleton
                        variant="text"
                        width={120}
                        sx={{ fontSize: '1.25rem', mt: 3, mb: 1 }}
                    />
                    <Stack direction="row" spacing={3} sx={{ alignItems: 'center', px: 1 }}>
                        <Skeleton
                            variant="rounded"
                            height={40}
                            sx={{ flexGrow: 1, maxWidth: 420 }}
                        />
                        {Array.from({ length: toggles }, (_, index) => (
                            <Skeleton key={index} variant="text" width={110} />
                        ))}
                        <Skeleton variant="circular" width={24} height={24} />
                    </Stack>

                    <Stack direction="row" spacing={2} sx={{ justifyContent: 'center', pt: 4 }}>
                        <Skeleton variant="rounded" width={280} height={40} />
                        <Skeleton variant="rounded" width={280} height={40} />
                    </Stack>
                </Paper>
            </Grid>
        </Grid>
    )
}
